import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from '@customink/pigment-react';

const propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node,
  options: PropTypes.string,
  popupName: PropTypes.string,
  onClick: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export default class PopupLink extends Component {
  static displayName = 'PopupLink';
  static propTypes = propTypes;

  static defaultProps = {
    name: 'popup-window',
    options: ''
  };

  /** @param {React.ChangeEvent<HTMLInputElement>} ev */
  handleClick = ev => {
    ev.preventDefault();
    this.props.onClick && this.props.onClick(ev);
    window.open(this.props.href, this.props.popupName, this.props.options);
  };

  render() {
    // eslint-disable-next-line no-unused-vars
    const {popupName, options, children, ...passedProps} = this.props;

    return (
      <Link button {...passedProps} rel="popup" onClick={this.handleClick}>
        {children}
      </Link>
    );
  }
}
